import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridComponent } from '@progress/kendo-angular-grid';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WorkflowActionModel } from 'src/app/ViewModel/WorkflowActionModel';
import { groupBy } from 'lodash';
import { Module } from 'src/app/Service/element-details.data.service';

const createFormGroup = (dataItem: any) => new FormGroup({
	"workflow_Id": new FormControl(dataItem.workflow_Id), // ui maintain
	"task_Id": new FormControl(dataItem.task_Id), // ui maintain
	"action_Id": new FormControl(dataItem.action_Id), // cart
	"action_Description": new FormControl(dataItem.action_Description), // cart
	"next_Step_Id": new FormControl(dataItem.next_Step_Id), // text
	"status_Id": new FormControl(dataItem.status_Id), // text
	"enable_Tag": new FormControl(dataItem.enable_Tag), // switch
	"is_Default": new FormControl(dataItem.is_Default), // switch
	"is_Active": new FormControl(dataItem.is_Active), // switch
});


@Component({
	selector: 'app-wft-action-dialog',
	templateUrl: './wft-action-dialog.component.html',
	styleUrls: ['./wft-action-dialog.component.css']
})


export class WftActionDialogComponent implements OnInit {
	@ViewChild(GridComponent)
	private grid!: GridComponent;
	@Input() ProjectId: number | null = null;
	@Input() GroupId: number | null = null;
	cartRequest = {};
	cartEventList: any[] = [];
	actionList: RoleFeatureModel[] = [];
	/** Selected cart list. Right side data */
	selectedActionList: any[] = [];
	kendoData: WorkflowActionModel[] = [];
	prevActionSelectedList: any[] = [];
	editedRowIndex: number | null = null;
	formGroup!: FormGroup;
	parentData!: { 'selectedEventList': any[], 'SelectedPrevActions': any[] };

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: { 'selectedEventList': any[], 'SelectedPrevActions': any[], 'is_Approval_Status'?: any },
		public dialogRef: MatDialogRef<WftActionDialogComponent>,
		public workflowTemplateService: WorkflowTemplateService,
	) { }

	ngOnInit() {
		this.parentData = this.data;
		this.getActionList();
	}

	getActionList() {
		this.workflowTemplateService.getWorkflowTaskList(this.GroupId, Module.Workflow, "Workflow", null, "Workflow Action", null, null, this.ProjectId).subscribe(data => {
			this.actionList = data;
			this.setRightSideData();
		});
	}


	getApprovalStatusValue(getValue: boolean) {
		let value = getValue;
	}
	/**
	 * Set selected data from parent
	 */
	setRightSideData() {
		this.cartEventList = this.parentData.selectedEventList;
		this.prevActionSelectedList = this.parentData.SelectedPrevActions;

		this.selectedActionList = [];
		if (this.parentData.selectedEventList.length) {

			this.parentData.selectedEventList.forEach(each => {

				if (each.additionalValues) {
					this.selectedActionList.push(this.getAsCartSelectedValue(each.value, each.additionalValues.dedDescription));
				} else {
					let text = each.text.split('-'),
						value = text[0].trim(),
						name = text[1].trim();
					this.selectedActionList.push(this.getAsCartSelectedValue(value, name));
				}
			});
			let grpdData = groupBy(this.parentData.selectedEventList, 'value');

			let tempDataSource: any = [];

			this.actionList.forEach(each => {
				if (!(grpdData[each.dedId] && grpdData[each.dedId].length)) {
					tempDataSource.push(each);
				}
			});
			this.actionList = tempDataSource;
		}

		this.setCartParams();
	}

	closeDialog() {
		this.dialogRef.close(null);
	}

	/**
	 * Setting cart data
	 */
	setCartParams() {
		this.cartRequest = {
			'params': {
				'LockingType': 'P',
				'selectedCartItems': this.selectedActionList,
			},
			'settings': {
				'mode': 'popup',
				'textField': 'dedDescription',
				'valueField': 'dedId',
				'cartLabel': 'Actions',
				'minimumSelectedItemCount': 0
			},
			'dataSource': this.actionList,
		}
	}

	getSelectedCartItems(event: any) {
		this.cartEventList = event;
		this.setKendoData();
	}

	setKendoData() {
		let tempKendoData: WorkflowActionModel[] = [];
		let prevSelectedData: any[] = this.prevActionSelectedList;
		this.cartEventList.forEach((each, index) => {
			let newAction: WorkflowActionModel = {
				"workflow_Id": null, // null by default for creation
				"task_Id": null, // ui maintain
				"action_Id": each.value, // cart
				"action_Description": '', // cart
				"next_Step_Id": 0, // text
				"status_Id": null, // text
				"statusDescription": '',
				"enable_Tag": 0, // switch
				"is_Default": false, // switch
				"is_Active": true, // switch
			};

			if (each.additionalValues) {
				newAction.action_Description = each.additionalValues.dedDescription;
			} else {
				let text = each.text.split('-'),
					name = text[1].trim();
				newAction.action_Description = name;
				if (prevSelectedData.length > 0) {
					let actionId: number = +text[0].trim();
					let selectedAction = prevSelectedData.filter(x => x.action_Id == actionId)[0];
					newAction = Object.assign(selectedAction);
				}
			}
			tempKendoData.push(newAction);
		});
		this.kendoData = tempKendoData;
		this.save();
	}

	save() {
		let output: any = {
			'selectedIds': [],
			'selectedTextWithValue': [],
			'data': this.kendoData, // kendo data
			'selectedNames': [],
			'is_Approval_Status': this.data.is_Approval_Status,
			'selectedEventList': this.cartEventList // cart event list
		};
		this.dialogRef.close(output);
	}

	/**
	 * Change data to respective cart selected data format
	 * @param value 
	 * @param text 
	 */
	getAsCartSelectedValue(value: string | number, text: string) {
		value = value.toString().trim();
		text = text.trim();
		let output = {
			value,
			text: value + ' - ' + text
		};
		return output;
	}
}
